// @flow
import * as React from 'react';

import {makeStyles, Typography} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../assets/styles/colors';
import novedades from '../../../../assets/img/novedades.svg';
import soporteTecnico from '../../../../assets/img/soporteTecnico.svg';
import comunidad from '../../../../assets/img/comunidad.svg';
import emprendada from '../../../../assets/img/emprendada.svg';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {PropTypes} from 'prop-types';

import {connect} from 'react-redux';
import type {RootState} from '../../../index';

import type {Store} from '../../../../entities';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
  }),
  null
)(TelegramModal);

type Props = {|
  store?: Store,
  open: boolean,
  handleCloseModal: () => void,
|};

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4, 4, 1, 4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4, 0, 1, 0),
    },
  },
  title: {textAlign: 'center', fontWeight: 600, fontSize: '1.375rem'},
  subtitle: {
    textAlign: 'center',
    marginTop: theme.spacing(1),
    color: colors.grey700,
  },
  content: {
    marginTop: theme.spacing(2),
    borderRadius: '12px',
    backgroundColor: colors.grey200,
    paddingBottom: theme.spacing(2),
    maxWidth: 440,
  },
  community: {
    margin: theme.spacing(2, 2, 0, 2),
    minHeight: 90,
    padding: theme.spacing(2),
    borderRadius: '8px',
    boxShadow:
      'box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  cImage: {marginRight: theme.spacing(2)},
  cTitle: {fontWeight: 600},
  cDescription: {
    color: colors.grey700,
    fontSize: '0.75rem',
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(2),
    },
  },
  cJoinButton: {
    marginLeft: 'auto',
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(2),
      width: '100%',
    },
  },
  suggestFeaturesButton: {
    width: '100%',
    marginTop: theme.spacing(2),
    borderRadius: '12px',
    backgroundColor: colors.lightPurple,
    '& .MuiButton-label': {
      flexDirection: 'column',
    },
  },
  suggestFeaturesButtonTitle: {
    fontWeight: 600,
    fontSize: '0.875rem',
  },
  suggestFeaturesButtonSubtitle: {
    fontSize: '0.75rem',
    color: colors.grey700,
  },
  closeButton: {
    marginTop: theme.spacing(3),
    border: `1px solid ${colors.purple3}`,
    fontSize: '1rem',
    width: 240,
    height: 48,
    fontWeight: 600,
  },
}));

const communities = [
  {
    image: novedades,
    title: 'Novedades',
    description: 'Canal de notificaciones sobre las nuevas funcionalidades.',
    link: 'https://t.me/tiendada',
  },
  {
    image: soporteTecnico,
    title: 'Soporte técnico',
    description:
      '¿Tienes problemas? No te preocupes, escríbenos por este canal.',
    link: 'https://t.me/+dSmD9qVhu0RiYjNh',
    proOnly: true,
  },
  {
    image: comunidad,
    title: 'Comunidad TiendaDa',
    description: 'Conoce y connversa con otros emprendedores.',
    link: 'https://t.me/+aG2BTNuv5qU3MThh',
  },
  {
    image: emprendada,
    title: 'EmprendaDa',
    description: 'Sólo para mujeres emprendedoras.',
    link: 'https://t.me/+94G9bTj4ZHtiOWQ5',
  },
];

function TelegramModal(props: Props) {
  const {store, open, handleCloseModal} = props;
  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Typography className={classes.title}>
          Únete a nuestras comunidades
        </Typography>
        <Typography className={classes.subtitle}>
          Hemos creado canales por temáticas.
        </Typography>
        <div className={classes.content}>
          {communities.map(
            (c, i: number) =>
              (!c.proOnly ||
                (store &&
                  (store.storeTier.name >= 'TIER_3' ||
                    store.storeTier.name === 'TIER_11'))) && (
                <div key={c.title} className={classes.community}>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <img
                      className={classes.cImage}
                      src={c.image}
                      alt={c.title}
                    />
                    <div>
                      <Typography className={classes.cTitle}>
                        {c.title}
                      </Typography>
                      <Typography className={classes.cDescription}>
                        {c.description}
                      </Typography>
                    </div>
                  </div>
                  <CustomButton
                    className={classes.cJoinButton}
                    variant="contained"
                    color="primary"
                    href={c.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Unirse
                  </CustomButton>
                </div>
              )
          )}
        </div>
        {store &&
          (store.storeTier.name >= 'TIER_3' ||
            store.storeTier.name === 'TIER_11') && (
            <CustomButton
              className={classes.suggestFeaturesButton}
              href="https://forms.gle/YcA3xMMBg19uJRnh7"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Typography className={classes.suggestFeaturesButtonTitle}>
                ¿Te gustaría una nueva funcionalidad?
              </Typography>
              <Typography className={classes.suggestFeaturesButtonSubtitle}>
                ¡Cuéntanos! Llena este formulario.
              </Typography>
            </CustomButton>
          )}
        <CustomButton
          className={classes.closeButton}
          color="primary"
          onClick={handleCloseModal}
        >
          Cerrar
        </CustomButton>
      </div>
    </CustomModal>
  );
}

TelegramModal.propTypes = {
  store: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};
